module.exports = __webpack_public_path__ + "img/add.fc093b46.svg";